// Utils
import { getUserLanguage } from '@shopee-user/platform';

// Enums
import { Locale } from '@shopee-user/global';

// Constants
import { config } from '@shopee-user/platform';

import AuthBackgroundEn1X from '../../assets/auth-background/en/auth-background-1x.png';
import AuthBackgroundEnMX from '../../assets/auth-background/en/auth-background-1.5x.png';
import AuthBackgroundEn2X from '../../assets/auth-background/en/auth-background-2x.png';
import AuthBackgroundEn3X from '../../assets/auth-background/en/auth-background-3x.png';
import AuthBackgroundEn4X from '../../assets/auth-background/en/auth-background-4x.png';
import AuthBackgroundVi1X from '../../assets/auth-background/vi/auth-background-1x.png';
import AuthBackgroundViMX from '../../assets/auth-background/vi/auth-background-1.5x.png';
import AuthBackgroundVi2X from '../../assets/auth-background/vi/auth-background-2x.png';
import AuthBackgroundVi3X from '../../assets/auth-background/vi/auth-background-3x.png';
import AuthBackgroundVi4X from '../../assets/auth-background/vi/auth-background-4x.png';
import AuthBackgroundTh1X from '../../assets/auth-background/th/auth-background-1x.png';
import AuthBackgroundThMX from '../../assets/auth-background/th/auth-background-1.5x.png';
import AuthBackgroundTh2X from '../../assets/auth-background/th/auth-background-2x.png';
import AuthBackgroundTh3X from '../../assets/auth-background/th/auth-background-3x.png';
import AuthBackgroundTh4X from '../../assets/auth-background/th/auth-background-4x.png';
import AuthBackgroundBr1X from '../../assets/auth-background/br/auth-background-1x.png';
import AuthBackgroundBrMX from '../../assets/auth-background/br/auth-background-1.5x.png';
import AuthBackgroundBr2X from '../../assets/auth-background/br/auth-background-2x.png';
import AuthBackgroundBr3X from '../../assets/auth-background/br/auth-background-3x.png';
import AuthBackgroundBr4X from '../../assets/auth-background/br/auth-background-4x.png';
import AuthBackgroundId1X from '../../assets/auth-background/id/auth-background-1x.png';
import AuthBackgroundIdMX from '../../assets/auth-background/id/auth-background-1.5x.png';
import AuthBackgroundId2X from '../../assets/auth-background/id/auth-background-2x.png';
import AuthBackgroundId3X from '../../assets/auth-background/id/auth-background-3x.png';
import AuthBackgroundId4X from '../../assets/auth-background/id/auth-background-4x.png';

import AuthBackgroundRebrandVi1X from '../../assets/auth-background/vi/rebrand/auth-background-1x.png';
import AuthBackgroundRebrandViMX from '../../assets/auth-background/vi/rebrand/auth-background-1.5x.png';
import AuthBackgroundRebrandVi2X from '../../assets/auth-background/vi/rebrand/auth-background-2x.png';
import AuthBackgroundRebrandVi3X from '../../assets/auth-background/vi/rebrand/auth-background-3x.png';
import AuthBackgroundRebrandVi4X from '../../assets/auth-background/vi/rebrand/auth-background-4x.png';

import AuthBackgroundRebrandEn1X from '../../assets/auth-background/en/rebrand/auth-background-1x.png';
import AuthBackgroundRebrandEnMX from '../../assets/auth-background/en/rebrand/auth-background-1.5x.png';
import AuthBackgroundRebrandEn2X from '../../assets/auth-background/en/rebrand/auth-background-2x.png';
import AuthBackgroundRebrandEn3X from '../../assets/auth-background/en/rebrand/auth-background-3x.png';
import AuthBackgroundRebrandEn4X from '../../assets/auth-background/en/rebrand/auth-background-4x.png';

import AuthBackgroundMs1X from '../../assets/auth-background/ms/auth-background-1x.png';
import AuthBackgroundMsMX from '../../assets/auth-background/ms/auth-background-1.5x.png';
import AuthBackgroundMs2X from '../../assets/auth-background/ms/auth-background-2x.png';
import AuthBackgroundMs3X from '../../assets/auth-background/ms/auth-background-3x.png';
import AuthBackgroundMs4X from '../../assets/auth-background/ms/auth-background-4x.png';

// This background is region + language specific. Currently it's used in both VN, ID, MY region English translation
import AuthBackgroundRebrandFastReliableEn1X from '../../assets/auth-background/en/rebrand/fast-reliable/auth-background-1x.png';
import AuthBackgroundRebrandFastReliableEnMX from '../../assets/auth-background/en/rebrand/fast-reliable/auth-background-1.5x.png';
import AuthBackgroundRebrandFastReliableEn2X from '../../assets/auth-background/en/rebrand/fast-reliable/auth-background-2x.png';
import AuthBackgroundRebrandFastReliableEn3X from '../../assets/auth-background/en/rebrand/fast-reliable/auth-background-3x.png';
import AuthBackgroundRebrandFastReliableEn4X from '../../assets/auth-background/en/rebrand/fast-reliable/auth-background-4x.png';

import AuthBackgroundRebrandId1X from '../../assets/auth-background/id/rebrand/auth-background-1x.png';
import AuthBackgroundRebrandIdMX from '../../assets/auth-background/id/rebrand/auth-background-1.5x.png';
import AuthBackgroundRebrandId2X from '../../assets/auth-background/id/rebrand/auth-background-2x.png';
import AuthBackgroundRebrandId3X from '../../assets/auth-background/id/rebrand/auth-background-3x.png';
import AuthBackgroundRebrandId4X from '../../assets/auth-background/id/rebrand/auth-background-4x.png';

import AuthBackgroundRebrandTh1X from '../../assets/auth-background/th/rebrand/auth-background-1x.png';
import AuthBackgroundRebrandThMX from '../../assets/auth-background/th/rebrand/auth-background-1.5x.png';
import AuthBackgroundRebrandTh2X from '../../assets/auth-background/th/rebrand/auth-background-2x.png';
import AuthBackgroundRebrandTh3X from '../../assets/auth-background/th/rebrand/auth-background-3x.png';
import AuthBackgroundRebrandTh4X from '../../assets/auth-background/th/rebrand/auth-background-4x.png';

const { LOCALE } = config;

export function getDefaultAuthDesktopBackgroundImage() {
  switch (LOCALE) {
    case Locale.VN: {
      if (getUserLanguage() === 'vi') {
        return AuthBackgroundRebrandVi1X as string;
      }
      return AuthBackgroundRebrandFastReliableEn1X as string;
    }
    case Locale.TH: {
      if (getUserLanguage() === 'th') {
        return AuthBackgroundRebrandTh1X as string;
      }
      return AuthBackgroundRebrandEn1X as string;
    }
    case Locale.PH:
    case Locale.SG: {
      return AuthBackgroundRebrandEn1X as string;
    }
    case Locale.ID: {
      if (getUserLanguage() === 'id') {
        return AuthBackgroundRebrandId1X as string;
      }
      return AuthBackgroundRebrandFastReliableEn1X as string;
    }
    case Locale.MY: {
      if (getUserLanguage() === 'ms') {
        return AuthBackgroundMs1X as string;
      }
      return AuthBackgroundRebrandFastReliableEn1X as string;
    }
    case Locale.BR: {
      return AuthBackgroundBr1X as string;
    }
    default:
      switch (getUserLanguage()) {
        case 'vi':
          return AuthBackgroundVi1X as string;
        case 'th':
          return AuthBackgroundTh1X as string;
        case 'id':
          return AuthBackgroundId1X as string;
        default:
          return AuthBackgroundEn1X as string;
      }
  }
}

export function getAuthDesktopBackgroundImageSet() {
  switch (LOCALE) {
    case Locale.VN: {
      if (getUserLanguage() === 'vi') {
        return [
          `${AuthBackgroundRebrandVi1X as string} 1x`,
          `${AuthBackgroundRebrandViMX as string} 1.5x`,
          `${AuthBackgroundRebrandVi2X as string} 2x`,
          `${AuthBackgroundRebrandVi3X as string} 3x`,
          `${AuthBackgroundRebrandVi4X as string} 4x`,
        ].join(',');
      }
      return [
        `${AuthBackgroundRebrandFastReliableEn1X as string} 1x`,
        `${AuthBackgroundRebrandFastReliableEnMX as string} 1.5x`,
        `${AuthBackgroundRebrandFastReliableEn2X as string} 2x`,
        `${AuthBackgroundRebrandFastReliableEn3X as string} 3x`,
        `${AuthBackgroundRebrandFastReliableEn4X as string} 4x`,
      ].join(',');
    }
    case Locale.TH: {
      if (getUserLanguage() === 'th') {
        return [
          `${AuthBackgroundRebrandTh1X as string} 1x`,
          `${AuthBackgroundRebrandThMX as string} 1.5x`,
          `${AuthBackgroundRebrandTh2X as string} 2x`,
          `${AuthBackgroundRebrandTh3X as string} 3x`,
          `${AuthBackgroundRebrandTh4X as string} 4x`,
        ].join(',');
      }
      return [
        `${AuthBackgroundRebrandEn1X as string} 1x`,
        `${AuthBackgroundRebrandEnMX as string} 1.5x`,
        `${AuthBackgroundRebrandEn2X as string} 2x`,
        `${AuthBackgroundRebrandEn3X as string} 3x`,
        `${AuthBackgroundRebrandEn4X as string} 4x`,
      ].join(',');
    }
    case Locale.PH:
    case Locale.SG: {
      return [
        `${AuthBackgroundRebrandEn1X as string} 1x`,
        `${AuthBackgroundRebrandEnMX as string} 1.5x`,
        `${AuthBackgroundRebrandEn2X as string} 2x`,
        `${AuthBackgroundRebrandEn3X as string} 3x`,
        `${AuthBackgroundRebrandEn4X as string} 4x`,
      ].join(',');
    }
    case Locale.ID: {
      if (getUserLanguage() === 'id') {
        return [
          `${AuthBackgroundRebrandId1X as string} 1x`,
          `${AuthBackgroundRebrandIdMX as string} 1.5x`,
          `${AuthBackgroundRebrandId2X as string} 2x`,
          `${AuthBackgroundRebrandId3X as string} 3x`,
          `${AuthBackgroundRebrandId4X as string} 4x`,
        ].join(',');
      }
      return [
        `${AuthBackgroundRebrandFastReliableEn1X as string} 1x`,
        `${AuthBackgroundRebrandFastReliableEnMX as string} 1.5x`,
        `${AuthBackgroundRebrandFastReliableEn2X as string} 2x`,
        `${AuthBackgroundRebrandFastReliableEn3X as string} 3x`,
        `${AuthBackgroundRebrandFastReliableEn4X as string} 4x`,
      ].join(',');
    }
    case Locale.MY:
      if (getUserLanguage() === 'ms') {
        return [
          `${AuthBackgroundMs1X as string} 1x`,
          `${AuthBackgroundMsMX as string} 1.5x`,
          `${AuthBackgroundMs2X as string} 2x`,
          `${AuthBackgroundMs3X as string} 3x`,
          `${AuthBackgroundMs4X as string} 4x`,
        ].join(',');
      }
      return [
        `${AuthBackgroundRebrandFastReliableEn1X as string} 1x`,
        `${AuthBackgroundRebrandFastReliableEnMX as string} 1.5x`,
        `${AuthBackgroundRebrandFastReliableEn2X as string} 2x`,
        `${AuthBackgroundRebrandFastReliableEn3X as string} 3x`,
        `${AuthBackgroundRebrandFastReliableEn4X as string} 4x`,
      ].join(',');
    case Locale.BR:
      return [
        `${AuthBackgroundBr1X as string} 1x`,
        `${AuthBackgroundBrMX as string} 1.5x`,
        `${AuthBackgroundBr2X as string} 2x`,
        `${AuthBackgroundBr3X as string} 3x`,
        `${AuthBackgroundBr4X as string} 4x`,
      ].join(',');
    default:
      switch (getUserLanguage()) {
        case 'vi':
          return [
            `${AuthBackgroundVi1X as string} 1x`,
            `${AuthBackgroundViMX as string} 1.5x`,
            `${AuthBackgroundVi2X as string} 2x`,
            `${AuthBackgroundVi3X as string} 3x`,
            `${AuthBackgroundVi4X as string} 4x`,
          ].join(',');
        case 'th':
          return [
            `${AuthBackgroundTh1X as string} 1x`,
            `${AuthBackgroundThMX as string} 1.5x`,
            `${AuthBackgroundTh2X as string} 2x`,
            `${AuthBackgroundTh3X as string} 3x`,
            `${AuthBackgroundTh4X as string} 4x`,
          ].join(',');
        case 'id':
          return [
            `${AuthBackgroundId1X as string} 1x`,
            `${AuthBackgroundIdMX as string} 1.5x`,
            `${AuthBackgroundId2X as string} 2x`,
            `${AuthBackgroundId3X as string} 3x`,
            `${AuthBackgroundId4X as string} 4x`,
          ].join(',');
        default:
          return [
            `${AuthBackgroundEn1X as string} 1x`,
            `${AuthBackgroundEnMX as string} 1.5x`,
            `${AuthBackgroundEn2X as string} 2x`,
            `${AuthBackgroundEn3X as string} 3x`,
            `${AuthBackgroundEn4X as string} 4x`,
          ].join(',');
      }
  }
}
